import { ApolloLink, Observable } from '@apollo/client'
import { beginNetworkActivity } from '@/shared/lib/network-activity'

const AI_CHAT_OPERATION_MARKER = 'AiChat'

export const networkActivityLink = new ApolloLink((operation, forward) => {
  if (
    operation.operationName?.includes(AI_CHAT_OPERATION_MARKER) ||
    operation.getContext().globalLoader === false
  ) {
    return forward(operation)
  }

  return new Observable((observer) => {
    const end = beginNetworkActivity()
    const subscription = forward(operation).subscribe({
      complete: () => {
        end()
        observer.complete()
      },
      error: (error: unknown) => {
        end()
        observer.error(error)
      },
      next: (result) => observer.next(result),
    })

    return () => {
      end()
      subscription.unsubscribe()
    }
  })
})
